import { Map, OrderedSet } from 'immutable'
import * as actions from './popularActions'
import * as userActions from '../../user/userActions'

const initialState = Map({
  itemIds: OrderedSet(),
  loading: false,
  timestamp: null,
  failedToLoad: false,
  shouldUpdate: false,
  categoryId: null,
  tagId: null,
})

export default function popular(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_POPULAR:
      return state
        .set('loading', true)
        .set('failedToLoad', false)
        .set('shouldUpdate', false)

    case actions.FETCH_POPULAR_FAILURE:
      return state
        .set('loading', false)
        .set('timestamp', action.timestamp)
        .set('failedToLoad', true)
        .set('shouldUpdate', false)

    case actions.FETCH_POPULAR_SUCCESS:
      return state
        .set('loading', false)
        .set('itemIds', OrderedSet(action.response.data.map(item => item.id)))
        .set('timestamp', action.timestamp)
        .set('shouldUpdate', false)
        .set('categoryId', action.categoryId)
        .set('tagId', action.tagId)

    case userActions.LOGOUT_USER_SUCCESS:
    case userActions.SET_ACTIVE_USER_PROFILE:
      return state.set('shouldUpdate', true)

    default:
      return state
  }
}
